import * as React from "react";
import { forwardRef } from "react";
const SvgCLivLogo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 480 442", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.16667,0,0,4.16667,-5630.42,-450.167)" }, /* @__PURE__ */ React.createElement("path", { d: "M1419.5,176.586C1415.87,179.673 1411.19,181.546 1406.05,181.546C1394.59,181.546 1385.3,172.256 1385.3,160.795C1385.3,149.335 1394.59,140.045 1406.05,140.045C1411.19,140.045 1415.87,141.918 1419.5,145.005L1446.32,145.005C1440.01,128.929 1424.37,117.54 1406.05,117.54C1382.16,117.54 1362.8,136.907 1362.8,160.795C1362.8,184.685 1382.16,204.051 1406.05,204.051C1424.37,204.051 1440.01,192.663 1446.32,176.586L1419.5,176.586Z", style: {
  fill: "white",
  fillRule: "nonzero"
} }), /* @__PURE__ */ React.createElement("path", { d: "M1422.12,168.618L1446.37,168.618C1450.69,168.618 1454.19,165.116 1454.19,160.795C1454.19,156.475 1450.69,152.973 1446.37,152.973L1422.12,152.973C1417.8,152.973 1414.3,156.475 1414.3,160.795C1414.3,165.116 1417.8,168.618 1422.12,168.618Z", style: {
  fill: "rgb(58,84,165)",
  fillRule: "nonzero"
} })));
const ForwardRef = forwardRef(SvgCLivLogo);
export { ForwardRef as ReactComponent };
